import React from 'react';
import { styled } from '@linaria/react';
import { Flex } from '@daedalus/atlas/helpers/Flex';
import { Text } from '@daedalus/atlas/Text';
import { sanitizeHtml } from '@daedalus/core/src/_web/utils/dom';
import { FormattedMessageWrapper } from '@daedalus/core/src/localization/components/FormattedMessage';
import { ContentHotel } from '@findhotel/sapi/dist/types/packages/core/src/types';
import { ContentKey } from './types';
const HtmlContentWrapper = /*#__PURE__*/styled('div')({
  name: "HtmlContentWrapper",
  class: "h3j0w2q",
  propsAsIs: false
});
const HtmlContent = ({
  text
}: {
  text: string;
}) => <HtmlContentWrapper dangerouslySetInnerHTML={{
  __html: sanitizeHtml(text)
}} />;
interface Props {
  hotel: ContentHotel;
  contentKey: ContentKey;
}

/**
 * Renders any content property of a hotel
 * Return should always be wrapped in a single HTML node to allow layout with Stack
 */
export const HotelContent = ({
  hotel,
  contentKey
}: Props) => {
  return {
    checkInSpInst: <HtmlContent text={hotel.checkInSpInst} />,
    checkInMinAge: <Text>
        <FormattedMessageWrapper id="checkInMinAgeDescription" defaultMessage="Check-in must be done by someone who is at least {checkInMinAge} years old." values={{
        checkInMinAge: hotel.checkInMinAge
      }} />
      </Text>,
    feesMnd: <HtmlContent text={hotel.feesMnd} />,
    feesOpt: <HtmlContent text={hotel.feesOpt} />,
    checkInInst: <HtmlContent text={hotel.checkInInst} />,
    policies: <HtmlContent text={hotel.policies} />,
    deposit: <Flex.Column gap="s200">
        <Text>
          <FormattedMessageWrapper id="depositOverlayDescription" defaultMessage="You'll be required to pay the following fully refundable deposit:" />
        </Text>
        <HtmlContent text={hotel.deposit?.description} />
      </Flex.Column>
  }[contentKey];
};

require("./HotelContent.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./HotelContent.tsx");